module.exports = __webpack_public_path__ + "static/media/polygon.1f09711b.svg";